/**
 * A state object
 * @typedef {Object<string, any>} State
 * @property {array} stores Array of items
 */
/**
 * @type {State} state
 * @returns {State} state
 */
export default {
  searchParam: '',
  mapsApiReady: false,
  stores: [],
  location: {},
  syncedInputValues: []
};
